import type { ComponentProps } from "react";

import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon } from "lucide-react";

import { cn } from "utils/cn";

import { FormControl, FormItem, FormMessage } from "components/Form";
import Label from "components/Label";

interface CheckboxProps extends ComponentProps<typeof CheckboxPrimitive.Root> {
  label?: string;
  className?: string;
}

export default function Checkbox({ className, ...props }: CheckboxProps) {
  const { id, disabled, label } = props;

  const checkboxComponent = (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "cursor-pointer peer data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground border-general-gray-600 data-[state=checked]:border-general-green-900 focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[2px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none bg-general-green-900"
      >
        <CheckIcon className="size-3.5 stroke-general-gray-100" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
  return (
    <FormItem className={cn("w-full flex items-center gap-1.5", className)}>
      <FormControl>{checkboxComponent}</FormControl>

      <Label htmlFor={id} className={cn(disabled ? "opacity-50" : "", "cursor-pointer select-none")}>
        {label}
      </Label>
      <FormMessage />
    </FormItem>
  );
}
